enum ModalMutationOptions {
    activateModal = "ACTIVATE_MODAL",
    closeModal = "CLOSE_MODAL"
}

export { ModalMutationOptions }
